import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'toPipe'
})
export class ToPipePipe implements PipeTransform {

    transform(callback: any, ...optionalParams: any[]): any {
        if (typeof callback === 'function') {
            if(optionalParams.length > 0) {
                return callback(...optionalParams);
            } else {
                return callback();
            }
        }
        return "";
    }
}
